import { useEffect, useState } from "react";
import {
  Col,
  Container,
  Row,
  FormGroup,
  Label,
  Input,
  FormFeedback,
  Button,
  Form,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Toast,
  ToastBody,
  ToastHeader,
  Spinner,
} from "reactstrap";
import { updateUser } from "src/slices/thunks";
import { Link, useNavigate, useParams } from "react-router-dom";
import "flatpickr/dist/themes/material_blue.css";
import * as Yup from "yup";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import avatar1 from "../../assets/images/users/avatar-1.jpg";
import { CardBody, Card } from "reactstrap";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "src";
import { getUserById, deleteUser, getUsers } from "src/slices/User/thunk";
import useToast from "src/components/Common/toast";
import { setToast } from "src/slices/toast/reducer";
import { resetUser } from "src/slices/User/reducer";

const UserUpdate = () => {
  document.title = "Definições de Utilizador | Khozi";
  const dispatch = useDispatch<AppDispatch>();
  const [modal, setModal] = useState<boolean>(false);
  const { id } = useParams();
  const navigate = useNavigate();
  const user = useSelector((state: any) => state.users.user);
  const userUnit = useSelector((state: any) =>
    state.unitsUsers.unitsUsers.find(
      (unitUser: any) => unitUser.user === Number(id)
    )
  );
  const users = useSelector((state: any) =>
    state.users.users.filter((user: any) => user.id !== id)
  );

  useEffect(() => {
    dispatch(resetUser());
    dispatch(getUserById(id));
  }, [id]);

  const toggle = () => {
    setModal(!modal);
  };

  const superior = useSelector((state: any) =>
    state.users.users.find((u: any) => u.id === user?.supervisor_id)
  );

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      username: `${user?.username}`,
      first_name: `${user?.first_name}`,
      last_name: `${user?.last_name}`,
      email: `${user?.email}`,
      telephone: `${user?.telephone.replace(/^\+258/, "")}`,
      superior: user?.supervisor_id,
      role: `${user?.role}`,
      status: `${user?.status}`,
      password: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      username: Yup.string().required("Por favor, insira o nome de utilizador"),
      first_name: Yup.string().required("Por favor, insira o nome completo"),
      last_name: Yup.string().required("Por favor, insira o nome completo"),
      email: Yup.string().required("Por favor, insira o email"),
      telephone: Yup.string().required("Por favor, insira o telefone"),
      superior: Yup.number().nullable().optional(),
      role: Yup.string().required("Por favor, insira a função"),
      status: Yup.string().required("Por favor, insira o status"),
      password: Yup.string().optional(),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("password"), undefined], "As senhas devem coincidir")
        .optional(),
    }),
    onSubmit: values => {
      dispatch(updateUser({ ...values, id: user.id })).then(() => {
        navigate("/users");
        dispatch(setToast({ action: "update-success" }));
        dispatch(getUsers());
      });
    },
  });

  const { show, ToastComponent } = useToast();

  const handleDelete = () => {
    toggle();
    dispatch(deleteUser(user.id)).then((response: any) => {
      if (
        typeof response.payload === "string" &&
        response.payload.includes("Request failed with")
      ) {
        show("Erro", "Ocorreu um erro ao apagar o utilizador");
      } else {
        dispatch(setToast({ action: "delete-success" }));
        navigate("/users?");
        dispatch(getUsers());
      }
    });
  };

  const normalizeRole = (role: string | undefined): string => {
    switch (role) {
      case "AD":
        return "Administrador";
      case "EX":
        return "Executivo";
      case "OP":
        return "Planificador";
      default:
        return "-";
    }
  };

  if (!user)
    return (
      <div
        style={{
          height: "100vh",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Spinner color="primary" />
      </div>
    );

  return (
    <div className="page-content">
      <Container fluid>
        {ToastComponent}
        <Breadcrumbs
          title="Utilizadores"
          breadcrumbItem="Definições de Utilizador"
        />
        <Row>
          <Row className="col-xxl-3 col-lg-4">
            <Card>
              <CardBody>
                <div
                  className="profile-bg position-relative overflow-hidden rounded-top"
                  style={{ height: "150px" }}
                >
                  <div className="bg-overlay bg-dark bg-gradient"></div>

                  <div className="position-relative p-3 text-end">
                    <button type="button" className="btn btn-primary btn-sm">
                      <i className="mdi mdi-pencil me-1"></i> Edit
                    </button>
                  </div>
                </div>
                <div className="text-center">
                  <div className="position-relative d-inline-block mx-auto mt-n5 mb-4">
                    <div className="avatar-lg">
                      <img
                        src={avatar1}
                        alt=""
                        className="rounded-circle img-thumbnail"
                      />
                    </div>
                    <Link
                      to="#"
                      className="d-block position-absolute bottom-0 end-0"
                    >
                      <div className="avatar-sm">
                        <div className="avatar-title rounded-circle bg-light text-primary">
                          <i className="mdi mdi-pencil"></i>
                        </div>
                      </div>
                    </Link>
                  </div>

                  <h5 className="font-size-16 mb-1">{`${user?.first_name} ${user?.last_name}`}</h5>
                  <p className="text-muted mb-0">{normalizeRole(user?.role)}</p>
                </div>
                <hr className="my-4" />
                <div>
                  <h5 className="font-size-16">Informações</h5>

                  <div className="mt-4">
                    <p className="text-muted mb-1">Nome:</p>
                    <h5 className="font-size-14 text-truncate">{`${user?.first_name} ${user?.last_name}`}</h5>
                  </div>

                  <div className="mt-4">
                    <p className="text-muted mb-1">Email</p>
                    <h5 className="font-size-14 text-truncate">
                      {user?.email}
                    </h5>
                  </div>

                  <div className="mt-4">
                    <p className="text-muted mb-1">Superior</p>
                    <h5 className="font-size-14 text-truncate">
                      {superior
                        ? `${superior.first_name} ${superior.last_name}`
                        : "-"}
                    </h5>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Row>

          <div className="col-xxl-9 col-lg-8">
            <Card>
              <CardBody>
                <Form
                  className="needs-validation"
                  onSubmit={e => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                  }}
                >
                  <div className="card border shadow-none mb-5">
                    <div className="card-header d-flex align-items-center">
                      <div className="flex-shrink-0 me-3">
                        <div className="avatar-sm">
                          <div className="avatar-title rounded-circle btn-primary-subtle text-primary">
                            01
                          </div>
                        </div>
                      </div>
                      <div className="flex-grow-1">
                        <h5 className="card-title">Utilizador</h5>
                      </div>
                    </div>
                    <CardBody>
                      <div>
                        <Row>
                          <Col>
                            <FormGroup className="mb-3">
                              <Label htmlFor="validationCustom01">
                                Nome de Utilizador
                              </Label>
                              <Input
                                name="username"
                                placeholder="Insira o nome de utilizador"
                                type="text"
                                className="form-control"
                                id="validationCustom01"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.username || ""}
                                invalid={
                                  validation.touched.username &&
                                  validation.errors.username
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.username &&
                              validation.errors.username ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.username}
                                </FormFeedback>
                              ) : null}
                            </FormGroup>
                          </Col>
                        </Row>
                      </div>
                    </CardBody>
                  </div>

                  <div className="card border shadow-none mb-5">
                    <div className="card-header d-flex align-items-center">
                      <div className="flex-shrink-0 me-3">
                        <div className="avatar-sm">
                          <div className="avatar-title rounded-circle btn-primary-subtle text-primary">
                            02
                          </div>
                        </div>
                      </div>
                      <div className="flex-grow-1">
                        <h5 className="card-title">Informações de Perfil</h5>
                      </div>
                    </div>
                    <CardBody>
                      <Row>
                        <Col md="6">
                          <FormGroup className="mb-3">
                            <Label htmlFor="validationCustom01">Nome</Label>
                            <Input
                              name="first_name"
                              placeholder="Nome"
                              type="text"
                              className="form-control"
                              id="validationCustom01"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.first_name || ""}
                              invalid={
                                validation.touched.first_name &&
                                validation.errors.first_name
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.first_name &&
                            validation.errors.first_name ? (
                              <FormFeedback type="invalid">
                                {validation.errors.first_name}
                              </FormFeedback>
                            ) : null}
                          </FormGroup>
                        </Col>
                        <Col md="6">
                          <FormGroup className="mb-3">
                            <Label htmlFor="validationCustom01">
                              Sobrenome
                            </Label>
                            <Input
                              name="last_name"
                              placeholder="Sobrenome"
                              type="text"
                              className="form-control"
                              id="validationCustom01"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.last_name || ""}
                              invalid={
                                validation.touched.last_name &&
                                validation.errors.last_name
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.last_name &&
                            validation.errors.last_name ? (
                              <FormFeedback type="invalid">
                                {validation.errors.last_name}
                              </FormFeedback>
                            ) : null}
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="6">
                          <FormGroup className="mb-3">
                            <Label htmlFor="validationCustom02">Email</Label>
                            <Input
                              name="email"
                              placeholder="Email"
                              type="text"
                              className="form-control"
                              id="validationCustom02"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.email || ""}
                              invalid={
                                validation.touched.email &&
                                validation.errors.email
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.email &&
                            validation.errors.email ? (
                              <FormFeedback type="invalid">
                                {validation.errors.email}
                              </FormFeedback>
                            ) : null}
                          </FormGroup>
                        </Col>
                        <Col md="6">
                          <FormGroup className="mb-3">
                            <Label htmlFor="validationCustom01">Telefone</Label>
                            <div className="d-flex align-items-center">
                              <span className="me-2">+258</span>
                              <Input
                                name="telephone"
                                placeholder="Telefone"
                                type="text"
                                className="form-control"
                                id="validationCustom01"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.telephone || ""}
                                invalid={
                                  validation.touched.telephone &&
                                  validation.errors.telephone
                                    ? true
                                    : false
                                }
                              />
                            </div>

                            {validation.touched.telephone &&
                            validation.errors.telephone ? (
                              <FormFeedback type="invalid">
                                {validation.errors.telephone}
                              </FormFeedback>
                            ) : null}
                          </FormGroup>
                        </Col>

                        {/* <Col>
            <FormGroup className="mb-3">
              <Label htmlFor="validationCustom03">Nível</Label>
              <Input
                name="level"
                placeholder="Nível"
                type="select"
                className="form-control"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.level || ""}
                invalid={
                  validation.touched.level && validation.errors.level
                    ? true
                    : false
                }
              >
                <option value="">Selecione</option>
                <option value="1">Nivel 1</option>
                <option value="2">Nivel 2</option>
                <option value="3">Nivel 3</option>
                <option value="4">Nivel 4</option>
                <option value="5">Nivel 5</option>
                <option value="6">Nivel 6</option>
              </Input>
              {validation.touched.level &&
              typeof validation.errors.level === "string" ? (
                <FormFeedback type="invalid">
                  {validation.errors.level}
                </FormFeedback>
              ) : null}
            </FormGroup>
          </Col> */}
                      </Row>
                      <Row>
                        <Col md="6">
                          <FormGroup className="mb-3">
                            <Label htmlFor="validationCustom03">Superior</Label>
                            <Input
                              name="superior"
                              placeholder="Superior"
                              type="select"
                              className="form-control"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.superior || ""}
                              invalid={
                                validation.touched.superior &&
                                validation.errors.superior
                                  ? true
                                  : false
                              }
                            >
                              <option value="">Selecione</option>
                              {users.map((user: any) => (
                                <option value={user.id} key={user.id}>
                                  {user.first_name} {user.last_name}
                                </option>
                              ))}
                            </Input>
                          </FormGroup>
                        </Col>
                        <Col md="6">
                          <FormGroup className="mb-3">
                            <Label htmlFor="validationCustom04">Função</Label>
                            <Input
                              name="role"
                              placeholder="Função"
                              type="select"
                              className="form-control"
                              id="validationCustom04"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.role || ""}
                              invalid={
                                validation.touched.role &&
                                validation.errors.role
                                  ? true
                                  : false
                              }
                            >
                              <option value="">Selecione</option>
                              <option value="AD">Administrador</option>
                              <option value="EX">Executivo</option>
                              <option value="OP">Planificador</option>
                            </Input>
                            {validation.touched.role &&
                            validation.errors.role ? (
                              <FormFeedback type="invalid">
                                {validation.errors.role}
                              </FormFeedback>
                            ) : null}
                          </FormGroup>
                        </Col>

                        {/* <Col md="4">
            <FormGroup className="mb-3">
              <Label htmlFor="validationCustom05">Unidade</Label>
              <Input
                name="unit"
                placeholder="Unidade"
                type="select"
                className="form-control"
                id="validationCustom05"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.unit || ""}
                invalid={
                  validation.touched.unit && validation.errors.unit
                    ? true
                    : false
                }
              >
                <option value="">Selecione</option>
                {units.map((unit: any) => (
                  <option value={unit.id} key={unit.id}>
                    {unit.name}
                  </option>
                ))}
              </Input>
              {typeof validation.errors.unit === "string" ? (
                <FormFeedback type="invalid">
                  {validation.errors.unit}
                </FormFeedback>
              ) : null}
            </FormGroup>
          </Col> */}
                      </Row>
                      <Row>
                        <Col md="6">
                          <FormGroup className="mb-3">
                            <Label htmlFor="validationCustom05">Status</Label>
                            <Input
                              name="status"
                              placeholder="Status"
                              type="select"
                              className="form-control"
                              id="validationCustom05"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.status || ""}
                              invalid={
                                validation.touched.status &&
                                validation.errors.status
                                  ? true
                                  : false
                              }
                            >
                              <option value="">Selecione</option>
                              <option value="A">Ativo</option>
                              <option value="I">Inativo</option>
                              <option value="T">Temporario</option>
                            </Input>
                            {validation.touched.status &&
                            validation.errors.status ? (
                              <FormFeedback type="invalid">
                                {validation.errors.status}
                              </FormFeedback>
                            ) : null}
                          </FormGroup>
                        </Col>
                      </Row>
                    </CardBody>
                  </div>

                  <div className="card border shadow-none">
                    <div className="card-header d-flex align-items-center">
                      <div className="flex-shrink-0 me-3">
                        <div className="avatar-sm">
                          <div className="avatar-title rounded-circle btn-primary-subtle text-primary">
                            03
                          </div>
                        </div>
                      </div>
                      <div className="flex-grow-1">
                        <h5 className="card-title">Orgão de Estrutura</h5>
                      </div>
                    </div>
                    {userUnit ? (
                      <CardBody>
                        <Row>
                          <Col lg={6}>
                            <div className="mb-3">
                              <label htmlFor="workexperience-designation-input">
                                Nome
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="workexperience-designation-input"
                                placeholder="Enter Designation title"
                                value={userUnit?.unity_name}
                              />
                            </div>
                          </Col>
                          <Col lg={6}>
                            <div className="mb-3">
                              <label htmlFor="workexperience-companyname-input">
                                Tipo
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="workexperience-companyname-input"
                                placeholder="Enter Company name"
                                value={userUnit?.unity_org_type.name}
                              />
                            </div>
                          </Col>
                        </Row>

                        <div>
                          <label>Nivel</label>
                          <input
                            type="text"
                            className="form-control"
                            id="workexperience-companyname-input"
                            placeholder="Enter Company name"
                            value={userUnit?.level}
                          />
                        </div>
                        <Col className="mt-3">
                          <Link
                            to={`/units-users?user=${id}`}
                            style={{
                              cursor: "pointer",
                              paddingTop: "10px",
                              textDecoration: "underline",
                            }}
                          >
                            Editar orgão de estrutura do utilizador.
                          </Link>
                        </Col>
                      </CardBody>
                    ) : (
                      <div>
                        <Row>
                          <Col className="m-3">
                            <p>
                              Este utilizador não possui um orgão de estrutura
                              atribuido, clique{" "}
                              <Link
                                to={`/units-users/create?user=${id}`}
                                style={{ textDecoration: "underline" }}
                              >
                                aqui
                              </Link>{" "}
                              para atribuir um orgão de estrutura.
                            </p>
                          </Col>
                        </Row>
                      </div>
                    )}
                  </div>

                  <div className="d-flex flex-wrap gap-2 justify-content-end">
                    <Button type="button" color="danger" onClick={toggle}>
                      Apagar
                    </Button>
                    <Button color="primary" type="submit">
                      Actualizar
                    </Button>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </div>
        </Row>
        <Modal isOpen={modal} toggle={toggle} centered={true}>
          <ModalHeader toggle={toggle} tag="h4">
            Tem certeza?
          </ModalHeader>
          <ModalBody>Tem certeza que deseja apagar este utilizador?</ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={toggle}>
              Cancelar
            </Button>
            <Button color="danger" onClick={handleDelete}>
              Apagar
            </Button>
          </ModalFooter>
        </Modal>
      </Container>
    </div>
  );
};

export default UserUpdate;
